class Carousel {
  quickviewCarousel() {
    let slides = $('#quickViewModal .slides');
    slides.owlCarousel({
      loop: false,
      nav: true,
      items: 1,
      navText: ['', '']
    });

    slides.trigger('refresh.owl.carousel');
  }
  initCarouselComponent(){
    let carousels = $('.products-carousel .slides');
    carousels.each((id, el) => {
      $(el).owlCarousel(this.getSetting(el));
    });
    carousels.trigger('refresh.owl.carousel');
  }

  getSetting(element){
    let breakpoints = {
      small: 0,
      medium: 640,
      large: 1024,
    };
    let count = $(element).data('count').split('-');
    let isScrollable = $(element).data('scrollable');
    let setting = {
      loop: true,
      margin: 10,
      navText: ['', ''],
      mouseDrag: isScrollable,
      touchDrag: isScrollable,
      responsive: {
        [breakpoints.small]: {
          nav: false,
          dots: true,
          items: count[2]
        },
        [breakpoints.medium]: {
          nav: true,
          dots: false,
          items: count[1]
        },
        [breakpoints.large]: {
          nav: true,
          dots: false,
          items: count[0]
        }
      }
    }
    return setting;
  }
}
const carousel = new Carousel();
export default carousel;



// WEBPACK FOOTER //
// ./assets/scripts/components/carousel.js